export default __webpack_public_path__ + "static/media/Kiunalla2.479a063a.jpg";